<!-- 这是传入图片，当作背景的操作 -->
<template>
  <div :style="computedStyle" class="select-container pc-select-com">
    <slot></slot>
    <div :style="popoupStyle" class="pc-op-com">
      <div class="pc-op-wrapper">
        <div
          class="pc-op-item"
          v-for="(item, index) in op"
          :key="index"
          @click="selectItem(item.value)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import config from '@img/config.json';
const { support_image, is_mobile } = inject('GlobalStore');
import px2vw from '@/utils/px2vw_v2';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  order_key: {
    type: String,
    required: true,
  },
  size: {
    type: Object,
    required: false,
  },
  op: {
    type: Object,
    default: () => [],
  },
});

const emit = defineEmits(['selectItem']);

const bg = ref();

const computedStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  return {
    backgroundImage: `url(${bg.value})`,
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

const popoupStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  let bg = `${config['xialakuan-menpai'].src}.${support_image.value}`;

  return {
    'border-image-source': `url(${bg})`,
    width: px2vw(200, is_mobile.value),
    'border-image-slice': '40 40 45 64 fill',
    'border-image-width': '40px 40px 45px 64px',
  };
});

const selectItem = (school) => {
  emit('selectItem', school,  props.order_key);
};

onMounted(async () => {
  let src = config[props.src].src;
  bg.value = `${src}.${support_image.value}`;
});
</script>

<style  lang="scss" scoped>
.select-container {
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;

  &:hover {
    .pc-op-com {
      display: block;
    }
  }
}

.pc-select-com {
  font-size: 16px;
}

.pc-op-com {
  position: absolute;
  display: none;
  right: 96px;
  top: 156px;
  z-index: 10000;
}

.pc-op-item {
  width: 100%;
  display: block;
  line-height: 28px;

  &:hover {
    background-color: #0f1d7a;
  }
}

.pc-op-wrapper {
  padding: 8px;
}
</style>
